module.exports = __webpack_public_path__ + "static/dl-android@2x-872b8a9972258cddf5b7667b23a6c25b.png";